import React, { useEffect, useMemo, useState } from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";

import * as logoElitePass from 'images/logo/logo_elite_pass.png';
import * as logoScanSelect from 'images/logo/logo_scansource_select_colorido.png';
import * as logoSS from 'images/logo-sm.png';
import * as logoScancash from 'images/scancash.png';
import * as logoElite from 'images/logo-sm-elite.png';
import DashboardRequestService from "services/dashboard-request";

const listData = [
  {
    id: 0,
    icon: logoSS,
    show: true,
    imgSize: {
      w: 35,
      h: 35
    }
  },
  {
    id: 4,
    icon: logoElitePass,
    show: true,
    imgSize: {
      w: 75,
      h: 35
    }
  },
  {
    id: 5,
    icon: logoScanSelect,
    show: true,
    imgSize: {
      w: 75,
      h: 35
    }
  },
  {
    id: 1,
    icon: logoElite,
    show: true,
    imgSize: {
      w: 35,
      h: 35
    }
  },
  {
    id: 3,
    icon: logoScancash,
    styleImage: { transform: 'scale(2)' },
    show: true,
    imgSize: {
      w: 35,
      h: 35
    }
  },
]

export default function ChannelsDataRender({ fiscalYear }) {
  const [data, setData] = useState({names:[],data:[]})

  const [loadingTotal, setLoadingTotal] = useState(false)

  const names_default = useMemo(()=>{
    let names = fiscalYear.programs.map((program)=>{
      return {
        name: program.name,
        id: program.premium_id,
        props: ""
      }
    })
    return {names:[
      {
        name: "Ativos",
        id: 0,
        props: ""
      },
      ...names
    ], data:{}}
  },[fiscalYear]);

  useEffect(() => {
    setLoadingTotal(true)
    DashboardRequestService.getTotalInCurrentProgram({
      params: {
        __fiscal_year_id: fiscalYear.id
      },
    })
    .then(({ data }) => {
      // console.log("Channels data", data);
      setData(data);
    })
    .finally(() => setLoadingTotal(false));
  }, [fiscalYear, names_default]);

  return (
    <Col xl="3" lg="12" md="12">
      <Row className="justify-content-around h-100">
        {(loadingTotal?names_default:data).names.map((name, key) => {
          let id = name.id;
          let item = listData.filter(o=>o.id == id)[0];
          if(!item) return <></>;
          return (<>
            {item.show && (
              <Col className="p-1 pb-2" xl="12" md="auto" xs="12" key={key}>
                <Card.Body className="shadow bg-white rounded text-center h-100 w-100 d-flex flex-column align-items-center">
                  <div className='w-100 h-100 d-flex flex-column align-items-center justify-content-center'>
                    <img src={item.icon} width={item.imgSize.w} style={item.styleImage} />
                    <div className='mt-2'>
                      <span className="dashboard-card-h5">Canais {name.name}</span>
                      <h5 className="text-h5 font-weight-bold d-block mb-0" style={{ fontSize: "larger" }}>
                        {!loadingTotal ? data.data[name.props] : <Spinner animation="border" size="sm" />}
                      </h5>
                    </div>
                  </div>
                </Card.Body>
              </Col>
            )}
          </>)
        })}
      </Row>
    </Col>
  );
}